export default "__VITE_ASSET__C_mjuGem__"